export const getCarouselImagesForAnimationLoop = (state) => {
  const { kioskCarouselImages } = state

  return kioskCarouselImages.length > 1 ? [...kioskCarouselImages, kioskCarouselImages[0]] : kioskCarouselImages
}
